import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

import { getFileUploadTypes } from '../../../utils/utilities';
import { IMAGE_LIMITS } from '../../../utils/constants';

class AnomalyLocations extends Form {
	state = {
		data: { anomalyLocations: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		anomalyLocations: Joi.array().min(1).max(IMAGE_LIMITS.ANOMALY_LOCATIONS).required().label('Anomaly Location'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	componentDidMount() {
		if (this.props.initialAnomalyLocations) {
			this.setState({ data: { anomalyLocations: this.props.initialAnomalyLocations} });
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data.anomalyLocations);
		toastService.success('Anomaly Location(s) Updated Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderFileInput({
					max: IMAGE_LIMITS.ANOMALY_LOCATIONS,
					multiple: IMAGE_LIMITS.ANOMALY_LOCATIONS > 1,
					name: 'anomalyLocations',
					accept: 'image/*,application/pdf',
					label: 'Anomaly Locations',
					sublabel: 'Upload photos showing anomaly locations',
					types: getFileUploadTypes(),
					enforceImageCaptionUpdate: true,
				})}

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Anomaly Location(s)')}
				</div>
			</form>
		);
	}
}

export default AnomalyLocations;
